import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ShIconModule, ShPageHeaderComponent, ShPaginationComponent } from '@stylehaven/components';

import { DownloadActionCellComponent } from './components/cells/download-action-cell/download-action-cell.component';
import {
    DownloadCreationDateCellComponent,
    DownloadExpiryDateCellComponent
} from './components/cells/download-date-cell/download-date-cell.component';
import { DownloadFoutenCellComponent } from './components/cells/download-fouten-cell/download-fouten-cell.component';
import { DownloadNaamCellComponent } from './components/cells/download-naam-cell/download-naam-cell.component';
import { DownloadStatusCellComponent } from './components/cells/download-status-cell/download-status-cell.component';
import { DownloadsOverviewContainerComponent } from './containers/downloads-overview-container/downloads-overview-container.component';
import { DownloadsRoutingModule } from './downloads-routing.module';
import { DownloadsSandboxService } from './sandbox/downloads-sandbox.service';
import { DownloadService } from './services/download.service';
import { DownloadsColumnHandlerService } from './services/downloads-column-handler.service';
import { ColumnHandlerService } from '../record/services/column-handler.service';
import { RecordModule } from '../record/record.module';
import { DigihavenElementsModule } from '../elements/elements.module';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe';

@NgModule({
    declarations: [
        DownloadsOverviewContainerComponent,
        DownloadNaamCellComponent,
        DownloadStatusCellComponent,
        DownloadCreationDateCellComponent,
        DownloadExpiryDateCellComponent,
        DownloadFoutenCellComponent,
        DownloadActionCellComponent
    ],
    imports: [
        CommonModule,
        DownloadsRoutingModule,
        TranslateModule,
        ShPageHeaderComponent,
        ShIconModule,
        RecordModule,
        DigihavenElementsModule,
        ReadableDatePipeModule,
        ShPaginationComponent
    ],
    providers: [
        DownloadsSandboxService,
        DownloadService,
        { provide: ColumnHandlerService, useClass: DownloadsColumnHandlerService }
    ]
})
export class DownloadsModule {}
